export const installedToast = {
  title: 'This tracker is only intended to be installed once',
  description:
    'Please select another tracker to add or edit this tracker from the Active Trackers list.',
};
